import React from 'react'
import PropTypes from 'prop-types'

const Row2Columns = (props) => {
  return (
    <div className="form__group form__group--has-columns">
      <div className="form__column">
        {props.children[0]}
      </div>
      <div className="form__column">
        {props.children[1]}
      </div>
    </div>
  )
}

Row2Columns.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
}

export default Row2Columns


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/Row2Columns.js